// SEC9: sign out after 30 minutes without keyboard, mouse or touch activity.

export const IDLE_LIMIT_MS = 30 * 60 * 1000;

export function watchIdle(onIdle: () => void, limitMs = IDLE_LIMIT_MS): () => void {
  let last = Date.now();
  const touch = () => (last = Date.now());
  const events = ["pointerdown", "keydown", "wheel", "touchstart", "mousemove"] as const;
  events.forEach((e) => window.addEventListener(e, touch, { passive: true }));
  const timer = window.setInterval(() => {
    if (Date.now() - last >= limitMs) {
      window.clearInterval(timer);
      onIdle();
    }
  }, 30_000);
  return () => {
    window.clearInterval(timer);
    events.forEach((e) => window.removeEventListener(e, touch));
  };
}
